import React from "react";
import { useSelector } from "react-redux";
import VisitImg from "../../assest/Visit.png";
import CallImg from "../../assest/Call.png";
import EmailImg from "../../assest/Email.png";
import arrow from "../../assest/arrow.png";
import "./Form.css"; // Custom CSS file for additional styling

const Form = () => {
  const { language } = useSelector((state) => state.language);
  
  // Translation dictionary
  const translations = {
    gb: {
      // English
      getInTouch: "Get In Touch With Us",
      hearFromYou: "We'd love to hear from you. Please fill out this form or reach out to us directly using the information below to continue construction.",
      visitUs: "Visit Us",
      visitAddress: "Etihad Gharbia Contracting Co.<br />Riyadh, Kingdom of Saudi Arabia",
      callUs: "Call Us",
      callNumber: "+966 50 211 4467<br />Sunday - Thursday, 8AM - 5PM",
      emailUs: "Email Us",
      emailAddress: "info@egccsaudi.com<br />We'll respond within 24 hours",
      whatsapp: "WhatsApp",
      whatsappNumber: "+966 50 211 4467",
      contactFormTitle: "Get In Touch",
      fullNamePlaceholder: "Full Name*",
      emailPlaceholder: "Email Address*",
      phonePlaceholder: "Phone*",
      subjectPlaceholder: "Subject/Request*",
      messagePlaceholder: "Send Message...",
      sendMessage: "Send Message"
    },
    sa: {
      // Arabic
      getInTouch: "تواصل معنا",
      hearFromYou: "نود أن نسمع منك. يرجى ملء هذا النموذج أو التواصل معنا مباشرة باستخدام المعلومات أدناه لمتابعة البناء.",
      visitUs: "زيارتنا",
      visitAddress: "شركة اتحاد غربيا للمقاولات<br />الرياض، المملكة العربية السعودية",
      callUs: "اتصل بنا",
      callNumber: "٩٦٦ ٥٠ ٢١١ ٤٤٦٧+<br />الأحد - الخميس، ٨ صباحًا - ٥ مساءً",
      emailUs: "راسلنا عبر البريد",
      emailAddress: "info@egccsaudi.com<br />سوف نرد خلال 24 ساعة",
      whatsapp: "واتساب",
      whatsappNumber: "٩٦٦ ٥٠ ٢١١ ٤٤٦٧+",
      contactFormTitle: "تواصل معنا",
      fullNamePlaceholder: "الاسم الكامل*",
      emailPlaceholder: "عنوان البريد الإلكتروني*",
      phonePlaceholder: "الهاتف*",
      subjectPlaceholder: "الموضوع / الطلب*",
      messagePlaceholder: "أرسل رسالة...",
      sendMessage: "إرسال الرسالة"
    },
    fr: {
      // French
      getInTouch: "Contactez-nous",
      hearFromYou: "Nous aimerions avoir de vos nouvelles. Veuillez remplir ce formulaire ou nous contacter directement en utilisant les informations ci-dessous pour poursuivre la construction.",
      visitUs: "Visitez-nous",
      visitAddress: "Etihad Gharbia Contracting Co.<br />Riyad, Royaume d'Arabie Saoudite",
      callUs: "Appelez-nous",
      callNumber: "+966 50 211 4467<br />Dimanche - Jeudi, 8h - 17h",
      emailUs: "Écrivez-nous",
      emailAddress: "info@egccsaudi.com<br />Nous répondrons dans les 24 heures",
      whatsapp: "WhatsApp",
      whatsappNumber: "+966 50 211 4467",
      contactFormTitle: "Contactez-nous",
      fullNamePlaceholder: "Nom complet*",
      emailPlaceholder: "Adresse e-mail*",
      phonePlaceholder: "Téléphone*",
      subjectPlaceholder: "Sujet/Demande*",
      messagePlaceholder: "Envoyer un message...",
      sendMessage: "Envoyer le message"
    },
    de: {
      // German
      getInTouch: "Kontaktieren Sie uns",
      hearFromYou: "Wir würden gerne von Ihnen hören. Bitte füllen Sie dieses Formular aus oder wenden Sie sich direkt an uns, um den Bau fortzusetzen.",
      visitUs: "Besuchen Sie uns",
      visitAddress: "Etihad Gharbia Contracting Co.<br />Riad, Königreich Saudi-Arabien",
      callUs: "Rufen Sie uns an",
      callNumber: "+966 50 211 4467<br />Sonntag - Donnerstag, 8 - 17 Uhr",
      emailUs: "Schreiben Sie uns",
      emailAddress: "info@egccsaudi.com<br />Wir antworten innerhalb von 24 Stunden",
      whatsapp: "WhatsApp",
      whatsappNumber: "+966 50 211 4467",
      contactFormTitle: "Kontaktieren Sie uns",
      fullNamePlaceholder: "Vollständiger Name*",
      emailPlaceholder: "E-Mail-Adresse*",
      phonePlaceholder: "Telefon*",
      subjectPlaceholder: "Betreff/Anfrage*",
      messagePlaceholder: "Nachricht senden...",
      sendMessage: "Nachricht senden"
    }
  };

  // Get current translations based on language
  const t = translations[language] || translations.gb;

  return (
    <div className="container-fluid my-4">
      <div className="row">
        {/* Contact Information Column */}
        <div className="col-md-5">
          <div className="contact-info p-4 rounded shadow-sm">
            <h3 className="fw-bold mb-2 text-dark">{t.getInTouch}</h3>
            <p className="text-muted mb-4" dangerouslySetInnerHTML={{ __html: t.hearFromYou }} />

            <div className="d-flex align-items-start mb-4">
              <img src={VisitImg} alt="Visit" className="contact-icon" />
              <div>
                <h5 className="fw-bold text-maroon">{t.visitUs}</h5>
                <p className="text-muted mb-0" dangerouslySetInnerHTML={{ __html: t.visitAddress }} />
              </div>
            </div>

            <div className="d-flex align-items-start mb-4">
              <img src={CallImg} alt="Call" className="contact-icon" />
              <div>
                <h5 className="fw-bold text-maroon">{t.callUs}</h5>
                <p className="text-muted mb-0" dangerouslySetInnerHTML={{ __html: t.callNumber }} />
              </div>
            </div>

            <div className="d-flex align-items-start mb-4">
              <img src={EmailImg} alt="Email" className="contact-icon" />
              <div>
                <h5 className="fw-bold text-maroon">{t.emailUs}</h5>
                <p className="text-muted mb-0" dangerouslySetInnerHTML={{ __html: t.emailAddress }} />
              </div>
            </div>

            <div className="d-flex align-items-start">
              <img src={EmailImg} alt="WhatsApp" className="contact-icon" />
              <div>
                <h5 className="fw-bold text-maroon">{t.whatsapp}</h5>
                <p className="text-muted mb-0" dangerouslySetInnerHTML={{ __html: t.whatsappNumber }} />
              </div>
            </div>
          </div>
        </div>

        {/* Contact Form Column */}
        <div className="col-md-7">
          <div className="contact-form p-4 rounded shadow-lg">
            <h3 className="fw-bold mb-2 text-dark">{t.contactFormTitle}</h3>
            <p className="text-muted mb-4" dangerouslySetInnerHTML={{ __html: t.hearFromYou }} />

            <form>
              <div className="row mb-3">
                <div className="col-md-6 mb-3 mb-md-0">
                  <input
                    type="text"
                    className="form-control rounded-pill py-2"
                    id="firstName"
                    placeholder={t.fullNamePlaceholder}
                    style={{ backgroundColor: "#f0f0f0" }}
                  />
                </div>
                <div className="col-md-6">
                  <input
                    type="email"
                    className="form-control rounded-pill py-2"
                    id="email"
                    placeholder={t.emailPlaceholder}
                    style={{ backgroundColor: "#f0f0f0" }}
                  />
                </div>
              </div>

              <div className="mb-3">
                <input
                  type="tel"
                  className="form-control rounded-pill py-2"
                  id="phone"
                  placeholder={t.phonePlaceholder}
                  style={{ backgroundColor: "#f0f0f0" }}
                />
              </div>

              <div className="mb-3">
                <input
                  type="text"
                  className="form-control rounded-pill py-2"
                  id="subject"
                  placeholder={t.subjectPlaceholder}
                  style={{ backgroundColor: "#f0f0f0" }}
                />
              </div>

              <div className="mb-3">
                <textarea
                  className="form-control py-2"
                  id="message"
                  rows="4"
                  placeholder={t.messagePlaceholder}
                  style={{ backgroundColor: "#f0f0f0", resize: "none" }}
                ></textarea>
              </div>

              <button type="submit" className="btn send-btn rounded-pill py-2 fw-bold">
                {t.sendMessage}
                <img src={arrow} alt="Arrow" className="ms-2" style={{ width: "20px" }} />
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Form;